import { computed, ref } from "@vue/composition-api";
import { Web, URI } from "sip.js";
const {
  SimpleUser,
  simpleUserDelegate,
  RegistererUnregisterOptions,
  Inviter,
  UserAgent,
} = Web;
import store from "@/store";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { EventBus } from "@/libs/event-bus";

export default function useIotcomms(device) {
  const isOnCall = computed(() => store.state.sip.isOnCall);
  const isCalling = computed(() => store.state.sip.isCalling);
  const isHolded = computed(() => store.state.sip.isHolded);
  const isRinging = computed(() => store.state.sip.isRinging);

  const isConnected = ref("Disconnected");
  const isMuted = ref(false);
  const intervalRefresh = ref(true); //To know if it should try to connect in the interval
  let intervalId = null; // To not repeat the interval, and create many intervals.
  const callingNumber = ref("");
  const callRecieved = ref({ callingPartyNumber: "" });
  const presavedCaller = store.state.sip.presavedCaller;
  const lockAnswerCall = ref(false);
  const toast = useToast();
  const isRegistered = store.state.sip.isRegistered;
  const presavedAlarm = computed(() => {
    return store.state.sip.presavedAlarm;
  });
  const shouldDisconnect = ref(true);


   //Cronometer for calls
   const cronometerRef = ref(null);
   const timeCall = computed(() => store.state.sip.timeCall);

  let simpleUser;

  const simpleUserDelegate = {
    onCallCreated: () => {
      // console.log({ simpleUser });
    },
    onCallAnswered: () => {
      store.dispatch("sip/setIsRinging", false);
      store.dispatch("sip/setIsCalling", false);
      store.dispatch("sip/setIsOnCall", true);
      store.dispatch("sip/setActiveSessionProvider", "iotcomms");
      store.dispatch("sip/setIconColor", "orange");
      startCronometer();
    },
    onCallHangup: () => {
      store.dispatch("sip/setIsRinging", false);
      store.dispatch("sip/setIsCalling", false);
      store.dispatch("sip/setIsOnCall", false);
      store.dispatch("sip/setActiveSessionProvider", "");
      store.dispatch("sip/setIconColor", "white");
      store.dispatch("sip/resetPresavedCaller");
      store.dispatch("sip/resetPresavedAlarm");
      if (simpleUser.session) hangUp();
      stopCronometer();
    },
    onCallHold: (held) => {
      isHolded.value = held;
    },
    onRegistered: () => {
      console.log(`[${device.user}] Register`);
    },
    onUnregistered: () => {
      console.log(`[${device.user}] Unregister`);
    },
    onCallReceived: () => {
      callRecieved.value = {
        callingPartyNumber:
          simpleUser.session.incomingInviteRequest.message.from.uri.normal.user,
      };
      if (
        store.state.sip.presavedCaller ==
          simpleUser.session.incomingInviteRequest.message.from.uri.normal.user ||
        simpleUser.session.incomingInviteRequest.message.from.uri.normal.user == "ivr"
      ) {
        answerCall();
      } else {
        toast({
          component: ToastificationContent,
          props: {
            title:
              "Nueva Llamada Entrante de " +
              simpleUser.session.incomingInviteRequest.message.from.uri.normal.user,
            icon: "PhoneCallIcon",
            variant: "success",
          },
        });
        store.dispatch("sip/setIsRinging", true);
        store.dispatch("sip/setIconColor", "green");
      }
      store
        .dispatch("sip/getDevice", {
          device_id:
            simpleUser.session.incomingInviteRequest.message.from.uri.normal.user,
        })
        .then((response) => {
          if (response.device?.units) {
            store.dispatch("sip/setDeviceCaller", response.device.units[0].description);
          } else if (response.user) {
            store.dispatch("sip/setDeviceCaller", response.user.email);
          } else {
            store.dispatch("sip/setDeviceCaller", simpleUser.session.incomingInviteRequest.message.from.uri.normal.user);
          }
        })
        .catch((e) => {
          toast(
            {
              component: ToastificationContent,
              props: {
                title: "Ocurrio un error al obtener la información del dispositivo",
                icon: "AlertTriangleIcon",
                variant: "danger",
              },
            },
            {
              timeout: 10000,
            }
          );
        })
        .finally(() => {
          console.error("Finally");
        });
    },
    onUnregistered: () => {
      store.dispatch("sip/setIconColor", "red");
      isConnected.value = "Unregistered";
    },
    onServerDisconnect: (error) => {
      console.error(`server disconected ${error}`);
      store.dispatch("sip/setIconColor", "red");
      isConnected.value = error;
    },
  };

  /**
   * Overrides the onMessage method of the SimpleUser's transport(websocket) to modify incoming messages.
   * Specifically in this case handles messages with multiple Record-Route headers by keeping only the first one.
   *
   * @param {SimpleUser} simpleUser - The SimpleUser instance whose onMessage method will be overridden.
   */
  const overrideOnMessageSipJs = (simpleUser) => {
    // Save the original onMessage method
    const originalOnMessage = simpleUser.userAgent.transport.onMessage;

    // Override the onMessage method
    simpleUser.userAgent.transport.onMessage = (message) => {
      //console.log("WebSocket received message:", message);
      // Search for Record-Route headers
      if (message.includes("Record-Route")) {
        const modifiedMessage = message.replace(/Record-Route:[^\r\n]*/g, (header) => {
          // Delete 'Record-Route:' header before the split
          const routesString = header.replace(/^Record-Route:\s*/, "");
          const routes = routesString.split(",");

          if (routes.length > 1) {
            // Keep just the first Record-Route
            return `Record-Route: ${routes[0].trim()}`;
          }
          return header; // If there is just one Record-Route, return original
        });

        // Call the original onMessage with the modified message
        return originalOnMessage.call(simpleUser.userAgent.transport, modifiedMessage);
      }

      // Call the original onMessage if no modification is necessary
      return originalOnMessage.call(simpleUser.userAgent.transport, message);
    };
  };

  const createUser = (audioElement) => {
    return new Promise((resolve, reject) => {
      try {
        let userAgent = {
          // traceSIP: true,
          logLevel: "log",
          displayName: device.user,
          authorizationPassword: device.password,
          authorizationUsername: device.user,
          uri: new URI("sip", device.user, device.domain),
          logBuiltinEnabled: true,
          viaHost: "omniview.cloud",
          hackViaTcp: false,
          authorizationHa1: device.ha1,
        };

        const simpleUserOptions = {
          delegate: simpleUserDelegate,
          media: {
            remote: {
              audio: audioElement,
            },
            // local: {
            //   audio: audioElementLocal,
            // },
          },
          userAgentOptions: userAgent,
        };

        simpleUser = new SimpleUser(device.websocket, simpleUserOptions);

        overrideOnMessageSipJs(simpleUser);

        resolve(simpleUser);
      } catch (error) {
        reject(error);
      }
    });
  };

  const connect = () => {
    simpleUser
      .connect()
      .then(() => {
        isConnected.value = "Connected";
        store.dispatch("sip/setIconColor", "white");
        store.dispatch("sip/setIsRegistered");

        simpleUser
          .register(
            { expires: 600 },
            {
              // An example of how to get access to a SIP response message for custom handling
              requestDelegate: {
                onReject: (response) => {
                  isConnected.value = "Registration Failed";
                  // store.dispatch("sip/unsetIsRegisted");
                },
              },
            }
          )
          .then(() => {
            store.dispatch("device_interphone/subscribeToForceDisconnect", {
              device_id: device.user,
              domain: device.domain
            });
            //alert(`[${simpleUser.id}] registered.\n`);
          })
          .catch((error) => {
            console.error(`[${simpleUser.id}] failed to register`);
            console.error(error);
            //alert(`[${simpleUser.id}] Failed to register.\n` + error);
          });
      })
      .catch((error) => {
        console.error(`[${simpleUser.id}] failed to connect`);
        console.error(error);
        //alert("Failed to connect.\n" + error);
      });
  };

  const unregister = () => {
    simpleUser
      .unregister()
      .then(() => {
        // console.log("Entro a UNREGISTER");
      })
      .catch((error) => {
        console.error(`[${simpleUser.id}] failed to unregister`);
        console.error(error);
        //alert(`[${simpleUser.id}] Failed to unregister.\n` + error);
      });
  };

  const hangUp = () => {
    simpleUser.hangup().catch((error) => {
      console.error(`[${simpleUser.id}] failed to hangup call`);
      console.error(error);
      //alert("Failed to hangup call.\n" + error);
    });
  };

  const takeCall = (sessionId, caller, alarm) => {
    lockAnswerCall.value = true;
    store
      .dispatch("sip/takeCall", {
        sessionId,
        user: device.user,
        presavedCaller: caller,
        alarm,
      })
      .then((response) => {
        toast({
          component: ToastificationContent,
          props: {
            title: response.message,
            icon: "CheckIcon",
            variant: "success",
          },
        });
      })
      .catch((e) => {
        toast(
          {
            component: ToastificationContent,
            props: {
              title: response.message,
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          },
          {
            timeout: 10000,
          }
        );
      })
      .finally(() => {
        lockAnswerCall.value = false;
        // props.disableEnableButtons(false);
        // props.closeLoading();
      });
  };

  const answerCall = () => {
    simpleUser.answer().catch((error) => {
      console.error(`[${simpleUser.id}] failed to answer call`);
      console.error(error);
      alert(`[${simpleUser.id}] Failed to answer call.\n` + error);
    });
  };

  const transferCall = () => {
    if (transferUser.value != "") {
      const target = new URI("sip", transferUser.value, device.domain);
      //TODO: make reactive variable
      let transferSession = simpleUser.session;
      simpleUser.hold();
      //Verificar si es .call y este valida si ya hay una sessión activa o .sendInvite por que este es privado
      simpleUser.sendInvite(target);
      simpleUser.session.refer(transferSession);
    }
    transferUser.value = "";
  };

  const holdSession = () => {
    simpleUser.hold();
  };

  const unHoldSession = () => {
    simpleUser.unhold();
  };

  const makeCall = (destination) => {
    if (isRinging.value || isOnCall.value) {
      toast({
        component: ToastificationContent,
        props: {
          title: "Ya estas en una llamada",
          icon: "PhoneCallIcon",
          variant: "Danger",
        },
      });
      return;
    }

    store.dispatch("sip/setIsCalling", true);
    store.dispatch("sip/setIconColor", "yellow");

    let setupCall = {inviteWithoutSdp: true};
    simpleUser.call(destination, setupCall).catch((error) => {
      console.error(`[${simpleUser.id}] failed tocall`);
      store.dispatch("sip/setIsCalling", false);
      store.dispatch("sip/setIconColor", "white");
      hangUp();
    });
  };

  const makeCallWithPresavedCall = (data) => {
    if (isRinging.value || isOnCall.value) {
      toast({
        component: ToastificationContent,
        props: {
          title: "Ya estas en una llamada",
          icon: "PhoneCallIcon",
          variant: "Danger",
        },
      });
      return;
    }

    store
      .dispatch("sip/setPresavedCall", {
        callingPartyNumber: simpleUser.id,
        remotePartyNumber: data.callingPartyNumber,
        id_alarm: data.id_alarm,
      })
      .then((response) => {
        makeCall("sip:" + data.callingPartyNumber + "@" + domain.value);
      })
      .catch((e) => {
        console.error({ e });
        this.showMessage("", e.message, "danger");
      })
      .finally(() => {});
  };

  const mute = () => {
    if (!isMuted.value) {
      isMuted.value = true;
      simpleUser.mute();
    } else {
      isMuted.value = false;
      simpleUser.unmute();
    }
  };

  const setUpSIP = () => {
    let audioElementAgain = document.getElementById("remoteAudio");
    let audioElementLocal = document.getElementById("localAudio");

    createUser(audioElementAgain, audioElementLocal)
      .then((simpleUser) => {
        connect();
      })
      .catch((e) => console.error(e));
  };

  const setUpInterval = () => {
    if (intervalId === null) {
      intervalId = setInterval(() => {
        if (!isOnCall.value) {
          if (!isRinging.value) {
            if (intervalRefresh.value) connect();
          }
        }
      }, 180000); //Cada 3.3 min
    }
  };

  const clearSetUpInterval = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
  };

  const forceConnectSIP = () => {
    axios.post("/v1/device_interphone/force_disconnect", {
      device_id: device.user,
      domain: device.domain
    });
    shouldDisconnect.value = false;
    setTimeout(() => {
      shouldDisconnect.value = true;
    }, 25000); //25 segundos para que se limpie bandera.
    setUpSIP();
    store.dispatch("sip/getAll");
    setUpInterval();
  };

  const disconnectSIP = () => {
    if (simpleUser) {
      let options = {
        requestOptions: {
          extraHeaders: ["Expires: 0"],
        },
      };

      simpleUser
        .unregister(options)
        .then((r) => {
          // console.log(r);
        })
        .catch((e) => {
          console.error(e);
        });
      simpleUser.disconnect();
    }
    intervalRefresh.value = false;
    clearSetUpInterval();
    store.dispatch("device_interphone/unSubscribeToForceDisconnect", {
      device_id: device.user,
      domain: device.domain
    });
  };

  const chronometer = () => {
    let time = timeCall.value + 1;
    store.dispatch("sip/setTimeCall", time);
  };

  const startCronometer = () => {
    cronometerRef.value = setInterval(chronometer, 1000);
  };

  const stopCronometer = () => {
    cronometerRef.value = clearInterval(cronometerRef.value);
    store.dispatch("sip/setTimeCall", 0);
  };

  EventBus.on(`take-call`, (params) => {
    if (params.provider == "iotcomms") takeCall(params.sessionId, params.caller, params.alarm)
  });

  EventBus.on(`hang-up`, (params) => {
    hangUp();
  });

  return {
    isOnCall,
    isRinging,
    isCalling,
    isConnected,
    isMuted,
    isHolded,

    createUser,
    disconnectSIP,
    connect,
    hangUp,
    makeCall,
    makeCallWithPresavedCall,
    mute,
    transferCall,
    holdSession,
    unHoldSession,
    forceConnectSIP,
    setUpInterval,
    startCronometer,
    stopCronometer,
    shouldDisconnect
  };
}
